export function formatDate(isoString: string): string {
  const date = new Date(isoString);

  // Options for the format: 3 July, 2025
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  return date.toLocaleDateString('en-GB', options);
}
